var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{staticClass:"looker",staticStyle:{"border":"0","display":"block","margin":"0 auto"},attrs:{"width":"70%","height":"auto","src":"https://lookerstudio.google.com/embed/reporting/fdfd3350-be3a-45d0-98a6-32d9ae72a138/page/p_2hg3jxlx5c","frameborder":"1","allowfullscreen":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }